'use client';
import React from 'react';
import DeltaBackdrop from './DeltaBackdrop';
import RotatingHeader from './RotatingHeader';

const Hero = () => {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    if (window.lenis) {
      window.lenis.scrollTo('#concepts');
    } else {
      // Fallback for when lenis is not available
      const conceptsSection = document.querySelector('#concepts');
      if (conceptsSection) {
        conceptsSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center text-center overflow-hidden">
      <DeltaBackdrop />
      <div className="container mx-auto px-6 relative z-10">
        <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-4 leading-snug">
          <RotatingHeader />
        </h1>
        <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto mt-6 mb-10">
          DeltaWeb. Měníme vaše vize v elegantní a funkční digitální realitu.
        </p>
        <a
          href="#concepts"
          onClick={handleScroll}
          className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
        >
          Prohlédnout galerii
        </a>
      </div>
    </section>
  );
};

export default Hero;